// extracted by mini-css-extract-plugin
module.exports = {"mark-completed":"MarkCompleted_mark-completed__20sW3","mark-completed--checked":"MarkCompleted_mark-completed--checked__rIDwb"};